export default function () {
  return {
    errors: {},
    success: false,
    error: false,
    editorOptions: {
      automaticLayout: true,
      formatOnType: true,
      formatOnPaste: true,
    },
    page: {
      title: '',
      body: '',
      menuName: '',
      icon: '',
    }
  }
}
